import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ListItemButton, Stack, Typography } from '@vapor/material'
import { faPlusLarge } from '@fortawesome/pro-light-svg-icons'
import { useTranslation } from 'react-i18next'

type AddPropertyProps = {
  onClick: () => void
  totalPlants: number
  unusedPlants: number
}
export const AddProperty = (props: AddPropertyProps) => {
  const { onClick, totalPlants, unusedPlants } = props
  const { t } = useTranslation()
  return (
    <ListItemButton sx={{ width: '100%' }} onClick={onClick} disabled={unusedPlants === 0}>
      <Stack direction={'row'} alignItems="center" width={'100%'} spacing={2}>
        <FontAwesomeIcon icon={faPlusLarge} />
        <Stack>
          <Typography variant="body">{t('pms.property_selection.create_property')}</Typography>
          <Typography variant="captionSmall">{t('pms.property_selection.unused_plants', { unused: unusedPlants ?? 0, total: totalPlants })}</Typography>
        </Stack>
      </Stack>
    </ListItemButton>
  )
}
